import { OutletState as e } from "@ancon/wildcat-types";
import t from "./isOutletAcceptingPreOrders.mjs";
import o from "./getOutletAvailableOrderFormats.mjs";
import s from "./getOutletOfflineOrderFormats.mjs";
import "./constants.mjs";
function p(r) {
  return r.state === e.Closed && t(
    r.orderFormatSettings
  ) ? s(
    r.supportedOrderFormats,
    r.orderFormatSettings
  ) : o(r.supportedOrderFormats);
}
export {
  p as default
};
